import { render, staticRenderFns } from "./categor.vue?vue&type=template&id=38771b16&scoped=true&"
import script from "./categor.vue?vue&type=script&lang=js&"
export * from "./categor.vue?vue&type=script&lang=js&"
import style0 from "./categor.vue?vue&type=style&index=0&id=38771b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38771b16",
  null
  
)

export default component.exports